import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from './../../../../Shared/Buttons/BtnSubmit';
import phoneIcon from './images/phoneIcon.svg'
import SongItem from '../../Shared/SongItem/SongItem'
import randomSongImg from './images/randomSong.png'
import {goToPage, setSelectedSubscriber} from '../../fundialSlice';
import userBig from './images/userBig.svg';

const SubscriberCard = (props) => {
    const hasService = (props.subscriber.fundialSubscriberStatus != "UNREGISTERED");

    function handleOnClick(subscriber){
        if(hasService){
            props.setSelectedSubscriber(subscriber);
            props.goToPage({page: 'personalAreaPage'});
        }
        else{
            props.setSelectedSubscriber(subscriber);
            props.goToPage({page: 'catalogPage'});
        }
    }

    return (
        <div className="subscriber-card">
            <span className="user-icon" style={{backgroundImage:userBig.bg()}}></span>
            <div className="header">
                <div className="subscriber">{props.subscriber.cli}</div>
            </div>
            <div className="content">
                {!hasService ? 
                <div className="new-subscriber">
                    <Image src={phoneIcon} />
                    <div className="text">
                        <div className="title">מנוי חדש?</div>
                        <p>הצטרף לשרות המתנה נעימה ותקדיש שיר מיוחד לכל מי שמתקשר אליך</p>
                    </div>
               </div>:
               props.subscriber.isShuffleMode ? 
               <div className="song-wrapper">
                    <div className="title">מנגן רשימת שירים רנדומלית</div>
                    <Image className="random-song" src={randomSongImg} />
                </div>
               :
               <div className="song-wrapper">
                   <div className="title">השיר שלי</div>
                    <SongItem isDisplayPlayer={false} playerSize={87} isDetailsFromLeft={true} onClickSong={() => {}} audio={{id: "default" ,image: props.subscriber.defaultSongImage ,description: props.subscriber.defaultSongTitle ,author: props.subscriber.defaultSongArtistName ,funtonPrevUrl: props.subscriber.defaultFuntonPrevUrl}} />
               </div>
                }
            </div>
            <div className="btn-wrapper">
                <BtnSubmit onclick={() => {handleOnClick(props.subscriber)}} text={hasService ? "לאיזור ניהול" : "להצטרפות"} formid="fundial-add-contact"></BtnSubmit>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedSubscriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberCard);